import styled from 'styled-components'

export const ComponentContainer = styled('div')`
  min-height: 84px;
  margin: 0px auto 20px;
  background: #f7f1ff;
  border-radius: 8px;
  padding: 12px;
`

export const SearchHeader = styled('div')`
  margin: 0px 0px 10px;
  line-height: 20px;
  display: flex;
  align-items: center;
  align-content: flex-start;
`

export const InfiniteIconWrapper = styled('span')`
  border-radius: 4px;
  width: 20px;
  height: 20px;
  border: none;
  background-color: #8e3df5;
  margin: 0 8px 0 0;
  padding: 4px 0 0 4px;
`
